/**
 * These are all of the possible values of the "type" field returned
 * from the workspace API ✌️
 */
export const TOUCHPOINT_TYPE_CARD = 'card';
export const TOUCHPOINT_TYPE_CONFIRMATION = 'confirmation';
export const TOUCHPOINT_TYPE_FORM = 'form';
export const TOUCHPOINT_TYPE_GUEST_APP = 'guestApp';
export const TOUCHPOINT_TYPE_PAGE = 'page';
export const TOUCHPOINT_TYPE_SESSION = 'session';
export const TOUCHPOINT_TYPE_TICKET_EDITOR = 'ticketSettings';
export const TOUCHPOINT_TYPE_TICKET_PURCHASE_FORM = 'ticketForm';
export const TOUCHPOINT_TYPE_VIRTUAL_EVENT = 'virtualEvent';
export const TOUCHPOINT_TYPE_BLOCK = 'block';
export const TOUCHPOINT_TYPE_AGENDA = 'agendaPage';

export const TITLE_CARD = 'Share Card';
export const TITLE_CONFIRMATION = 'Confirmations';
export const TITLE_FORM = 'Registration Form';
export const TITLE_FORMS = 'Registration Forms';
export const TITLE_GUEST_APP = 'Guest App';
export const TITLE_PAGE = 'Event Page';
export const TITLE_PAGE_THEME = 'Theme Page';
export const TITLE_WEBSITE_TEMPLATE = 'Website Template';
export const TITLE_SESSION = 'Sessions Page';
export const TITLE_TICKET_EDITOR = 'Ticket Editor';
export const TITLE_TICKET_PURCHASE_FORM = 'Ticket Purchase Form';
export const TITLE_VIRTUAL_EVENT = 'Virtual Event Page';
export const TITLE_AGENDA = 'Agenda Page';

export const TOUCHPOINT_TITLES = {
    [TOUCHPOINT_TYPE_CARD]: TITLE_CARD,
    [TOUCHPOINT_TYPE_CONFIRMATION]: TITLE_CONFIRMATION,
    [TOUCHPOINT_TYPE_FORM]: TITLE_FORM,
    [TOUCHPOINT_TYPE_GUEST_APP]: TITLE_GUEST_APP,
    [TOUCHPOINT_TYPE_PAGE]: TITLE_PAGE,
    [TOUCHPOINT_TYPE_SESSION]: TITLE_SESSION,
    [TOUCHPOINT_TYPE_TICKET_EDITOR]: TITLE_TICKET_EDITOR,
    [TOUCHPOINT_TYPE_TICKET_PURCHASE_FORM]: TITLE_TICKET_PURCHASE_FORM,
    [TOUCHPOINT_TYPE_VIRTUAL_EVENT]: TITLE_VIRTUAL_EVENT,
    [TOUCHPOINT_TYPE_AGENDA]: TITLE_AGENDA,
};
